import { useLocalPrice } from "../hooks/useLocalPrice";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";



export default function FAQSection() {
  const { bracket: localEstimate } = useLocalPrice(1.99, "USD");
  const priceHint = localEstimate ? ` ${localEstimate}` : "";
  const { t } = useTranslation();

  const FAQS = [
  {
    q: t("faq.q1"),
    a: t("faq.a1"),
  },
  {
    q: t("faq.q2"),
    a: t("faq.a2"),
  },
  {
    q: t("faq.q3"),
    a: t("faq.a3"),
  },
  {
    q: t("faq.q4", { priceHint }),
    a: t("faq.a4", { priceHint }),
  },
  {
    q: t("faq.q5"),
    a: t("faq.a5"),
  },
  {
    q: t("faq.q6"),
    a: t("faq.a6"),
  },
  {
    q: t("faq.q7"),
    a: t("faq.a7"),
  },
  {
    q: t("faq.q8"),
    a: t("faq.a8"),
  },
];


  return (
    <section id="faq" className="py-16 sm:py-20 border-t border-border/30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2
          className="text-4xl sm:text-5xl font-bold uppercase tracking-tight mb-8"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          {t("faq.heading")}
        </h2>

        <Accordion type="single" collapsible className="space-y-2">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-border/50 rounded-lg bg-card/40 px-4 data-[state=open]:bg-card/80 transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-start text-sm font-medium text-foreground py-4 hover:no-underline hover:text-primary transition-colors">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-4">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
